module.exports = __webpack_public_path__ + "static/media/logo-tem.09db5575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-tem.svg
// module id = 406
// module chunks = 0